import { css } from 'astroturf';
import React from 'react';
import { Download } from 'react-bytesize-icons';

const styles = css`
  .card {
    padding: 1rem;
    border-radius: 8px;
    background: #fff;
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.024),
      0 1px 0 rgba(0, 0, 0, 0.05),
      0 0 8px rgba(0, 0, 0, 0.03),
      0 5px 10px rgba(0, 0, 50, 0.1);
  }

  .itemCard {
    flex: 1 1 32%;
    max-width: 400px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0.5rem;

    @media (max-width: 40rem) {
      max-width: 100%;
    }
  }

  .actions {
    display: flex;
    gap: 0.5rem;
    margin-top: auto;
    padding-top: 0.5rem;

    button {
      border: 0;
      padding: 0.6rem 0.75rem;
      border-radius: 4px;
      font-weight: 600;
      font-size: 0.875rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 0.35rem;
    }
  }

  .download {
    color: #fff;
    transition: background 0.15s ease-in-out;
    background: rgb(76, 158, 192);

    .card:hover &,
    .card:focus-within & {
      background: rgb(16, 125, 181);
      &:hover,
      &:focus-visible {
        background: #008300;
      }
    }

    svg {
      width: 14px;
      height: 14px;
      stroke-width: 3px;
    }
  }
`;

export default function CatalogCard({ onDownload, extraActions, children, hideActions = false }) {
  return (
    <div className={[styles.itemCard, styles.card].join(' ')}>
      {children}
      {!hideActions ? (
        <div className={styles.actions}>
          <button className={styles.download} type="button" onClick={onDownload}>
            Download
            <Download />
          </button>
          {extraActions}
        </div>
      ) : null}
    </div>
  );
}
